import { useEffect } from "react";

export const useEvent = () => {
  const Events = {
    HeaderContent: {
      Id: "headercontent",
      Event: "event.headercontent"
    },
    RefreshTaskGrid: {
      Id: "refreshtaskgrid",
      Event: "event.refreshtaskgrid"
    },
    TaskOverlay: {
      Id: "task-overlay",
      Event: "event.toggletaskoverlay"
    },
    CloseTaskOverlay: {
      Id: "close-task-overlay",
      Event: "event.closetaskoverlay"
    },
    RefreshBoardPermissionGrid: {
      Id: "refreshboardpermissiongrid",
      Event: "event.refreshboardpermissiongrid"
    },
    SetTaskGridCount: {
      Id: "settaskgridcount",
      Event: "event.settaskgridcount"
    },
    TaskTemplateGrid: {
      Id: "tasktemplategrid",
      Event: "event.tasktemplategrid"
    },
    UpdateTaskTemplate: {
      Id: "updatetasktemplate",
      Event: "event.updatetasktemplate"
    },
    RefreshTaskTemplateGrid: {
      Id: "refreshtasktemplategrid",
      Event: "event.refreshtasktemplategrid"
    },
    ExportTaskGridToExcel: {
      Id: "exporttaskgridtoexcel",
      Event: "event.exporttaskgridtoexcel"
    },
    ImportLogOverlay: {
      Id: "import-log-overlay",
      Event: "event.toggleimportlogoverlay"
    },
    TaskTemplatesImportLogOverlay: {
      Id: "task-templates-import-log-overlay",
      Event: "event.toggletasktemplatesimportlogoverlay"
    },
    RefreshImportLogOverlay: {
      Id: "refreshimportlogoverlay",
      Event: "event.refreshimportlogoverlay"
    },
    ClosingExtendedDateModal: {
      Id: "closingExtendedDateModal",
      Event: "event.closingextendeddatemodal"
    },
    UpdateCustomFieldGroup: {
      Id: "updatecustomfieldgroup",
      Event: "event.updatecustomfieldgroup"
    }
  };

  const toggleEvent = (eventType, detail = undefined, uniqueId = undefined) => {
    const event = new CustomEvent(eventType.Event, {
      detail: detail,
      id: uniqueId
    });

    if (uniqueId) {
      event.uniqueId = uniqueId;
    }

    document.dispatchEvent(event);
  };

  const getElementId = (eventType, uniqueId) => {
    let result = `${eventType.Id}`;

    if (uniqueId) result = `${eventType.Id}-${uniqueId}`;

    return result;
  };

  const useRegisterCustomEvent = (eventType, event) => {
    useEffect(() => {
      if (eventType) {
        document.removeEventListener(eventType.Event, event);
        document.addEventListener(eventType.Event, event);

        return () => {
          document.removeEventListener(eventType.Event, event);
        };
      }
    }, [event]);
  };

  return { Events, getElementId, toggleEvent, useRegisterCustomEvent };
};

export default useEvent;
